import {useEffect} from 'react';
import {observer} from 'mobx-react';
import LoginForm from './LoginForm';
import LoginFormHeader from './LoginFormHeader';
import ForgotPasswordLink from './ForgotPasswordLink';
import {successAlert} from 'shared/tools';
import {t} from 'shared/core';

const UsernamePasswordForm = observer(({uiState}) => {
  const {isPartner = false, forgotPasswordHref} = uiState;

  const headerMessage = isPartner ? 'login.partner.Sign into Collage Partner Portal' : 'login.Sign into Collage';

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('password_reset_successful')) {
      successAlert(t('password_reset.Your password has been changed.'));
    }
  }, []);

  return (
    <div>
      <LoginFormHeader message={headerMessage} />
      <LoginForm uiState={uiState} />
      <ForgotPasswordLink href={forgotPasswordHref} />
    </div>
  );
});

export default UsernamePasswordForm;
